import React from "react";
import { HelpCircle } from "lucide-react";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from "./tooltip";
import { EDUSICO_COLORS } from "../../lib/colors";

interface HelpTooltipProps {
  term: string;
  explanation: string;
  example?: string;
}

export const HelpTooltip: React.FC<HelpTooltipProps> = ({
  term,
  explanation,
  example,
}) => {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="inline-flex items-center justify-center w-4 h-4 rounded-full shrink-0 cursor-help focus:outline-none focus:ring-2 focus:ring-offset-1"
            style={{
              backgroundColor: EDUSICO_COLORS.bgMuted,
              color: EDUSICO_COLORS.textMuted,
              focusRingColor: EDUSICO_COLORS.info,
            }}
            aria-label={`Ayuda: ${term}`}
          >
            <HelpCircle className="w-3 h-3" />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="right"
          sideOffset={8}
          className="max-w-xs p-3 rounded-xl border shadow-lg"
          style={{
            backgroundColor: EDUSICO_COLORS.bgPanel,
            borderColor: EDUSICO_COLORS.borderLight,
            color: EDUSICO_COLORS.textMain,
          }}
        >
          <div className="space-y-1.5">
            <p
              className="text-xs font-semibold font-sans"
              style={{ color: EDUSICO_COLORS.accent }}
            >
              {term}
            </p>
            <p
              className="text-[11px] leading-relaxed font-sans"
              style={{ color: EDUSICO_COLORS.textMuted }}
            >
              {explanation}
            </p>
            {example && (
              <p
                className="text-[11px] italic font-sans"
                style={{ color: EDUSICO_COLORS.textLight }}
              >
                Ejemplo: {example}
              </p>
            )}
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
